<template>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myLargeModalLabel" style="font-size: 14px;">Firmar Contrato</h4>
                <button ref="closeEmployeesSigningModal" class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <FirmaDigital ref="firmaDigital" @signProcess="signProcess" />
            </div>
            <div class="modal-footer">
                <button class="btn btn-info btn-sm" type="button" style="float: right;" title="btn btn-info btn-sm" @click="clearSignature">Limpiar</button>
                <button class="btn btn-primary btn-sm" type="button" style="float: right;" title="btn btn-success btn-sm" @click="saveSignature">Guardar Firma</button>
            </div>
        </div>
    </div>
</template>
<script>
import FirmaDigital from '@/components/tmkt/employees/employees_sign_canvas.vue'

import ws from '@/services/employees'
 
export default {
    name: 'employees_sign_modal', 
    mixins: [],
    props: {

    },
    components: {
        FirmaDigital 
    },
    data(){
        return{
            showModal: true,
            employee: null,
            contract_type: null
        }
    },
    methods: {
        async loadEmployee(employee, contract_type) {
            this.employee = employee;
            this.contract_type = contract_type;
        },
        async signProcess(firmaBase64) {
            let ip; 

            await fetch("https://api.ipify.org?format=json")
            .then(response => response.json())
            .then(data => {
                ip = data.ip;
            });

            let response = await ws.signContractProcess(this.employee, this.contract_type, firmaBase64, ip);

            if(response.type == "success"){
                this.$toast.success(response.message);

                this.closeModal();

                this.$emit("signed",response.data);
            }
            else{
                this.$toast.error(response.message);
            }
        },
        async saveSignature() {
            this.$refs.firmaDigital.saveSignature();
        },
        async clearSignature() {
            this.$refs.firmaDigital.clearSignature();
        },
        closeModal(){
            this.$refs.closeEmployeesSigningModal.click();
        }
    }
}
</script>